export default {
    ORDER_FULFILLMENT_STATUS: {
        FULFILLED: 'fulfilled',
        PARTIAL: 'partial',
        UNFULFILLED: 'unfulfilled'
    },
    FULFILLMENT_MODAL_STATUS: {
        FULL: 'full',
        PARTIAL: 'partial',
        NONE: 'none'
    },
    DEFAULT_FULFILLER: 'Local Inventory',
    FULFILLMENT_METHOD: {
        MANUAL: 'manual',
        LABEL: 'label'
    },
    PAYMENT_METHODS: {
        CASH: 'Cash',
        CREDIT: 'Credit Card',
        PO: 'Purchase Order',
        PAYPAL: 'PayPal'
    },
    SHIPPING_METHODS: {
        UPS: 'UPS',
        FEDEX: 'FedEx',
        USPS: 'USPS',
        DHL: 'DHL',
        PICKUP: 'In-person pickup'
    },
    NO_SHIPPING: 'Service - no shipping',
    SHIPPING_SETUP_ERRORS: {
        NO_STORE_ADDRESS: 'noStoreAddress',
        NO_PAYMENT_METHOD: 'noPaymentMethod',
        NO_DEFAULTS: 'noDefaults'
    },
    DISCOUNT_TYPE: {
        CUSTOM: 'custom',
        FIXED: 'fixed',
        PERCENT: 'percent'
    },
    PAYMENT_EVENT_TYPE: {
        ADJUSTMENT_CHARGE: 'AdjustmentCharge',
        CHARGE: 'charge',
        REAUTHORIZE: 'Reauthorize',
        REFUND: 'refund'
    }
};



// WEBPACK FOOTER //
// ./src/app/pages/orders/orderConstants.js